enum Statuses {
    'Active' = 1,
    'Blocked',
}

export default Statuses;
